import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormValidationUtils } from '../utils/form-validation-utils';
import * as moment from 'moment';

export function isoDateStringValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!control.value) {
    return null;
  }
  if (value === FormValidationUtils.INVALID_DATE_MARKER) {
    return { invalidDate: true };
  }

  if (typeof value !== 'string') {
    return { invalidDate: true };
  }

  const momentDate = moment(value, moment.ISO_8601, true);
  if (!momentDate.isValid()) {
    return { invalidDate: true };
  }
  return null;
}
